export function injectIframeScript(
  iframe: HTMLIFrameElement,
  script: string,
  scriptHash: string
) {
  const scriptElement = iframe.contentDocument?.createElement('script')
  if (!scriptElement) return

  scriptElement.setAttribute('data-container-injected', 'true')
  scriptElement.setAttribute('data-container-hash', scriptHash)

  scriptElement.innerHTML = `
    (function () {
      ${script}
    })()
  `

  iframe.contentDocument?.head.appendChild(scriptElement)
}
